import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from './components/ui/sonner';
import Navbar from "./components/site/Navbar";
import Footer from "./components/site/Footer";
import StickyCTA from "./components/site/StickyCTA";

import Home from "./pages/Home";
import About from "./pages/About";
import Experiences from "./pages/Experiences";
import Dining from "./pages/Dining";
import Events from "./pages/Events";
import Sustainability from "./pages/Sustainability";
import Gallery from "./pages/Gallery";
import Reviews from "./pages/Reviews";
import Feedback from "./pages/Feedback";
import Contact from "./pages/Contact";
import Policies from "./pages/Policies";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* Skip to main content link for keyboard accessibility */}
        <a 
          href="#main-content" 
          className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-[#C9A227] focus:text-[#111] focus:px-4 focus:py-2 focus:rounded-lg focus:font-semibold"
        >
          Skip to main content
        </a>
        <Navbar />
        <main id="main-content" className="min-h-screen bg-[#050706] text-[#F4F1E8]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            {/* Redirect /stay to home page Stay section */}
            <Route path="/stay" element={<Navigate to="/#stay" replace />} />
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/dining" element={<Dining />} />
            <Route path="/events" element={<Events />} />
            <Route path="/sustainability" element={<Sustainability />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/policies" element={<Policies />} />
          </Routes>
        </main>
        <Footer />
        <StickyCTA />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
